import * as types from "./mutation-types";
import Vue from "vue";

export default {
  [types.SET_CUSTOMER_TICKETS](state, { id, tickets }) {
    state.all = Object.assign({}, state.all, { [id]: {} });

    let ticketsMap = {};
    tickets.forEach(ticket => (ticketsMap[ticket.id] = ticket));
    state.all[id] = ticketsMap;
  },

  [types.ADD_CUSTOMER_TICKET](state, { customerId, ticket }) {
    if (!state.all[customerId]) {
      state.all = Object.assign({}, state.all, {
        [customerId]: {},
      });
    }

    state.all[customerId] = Object.assign({}, state.all[customerId], {
      [ticket.id]: ticket,
    });
  },

  [types.ADD_SHARE_TICKET_REQUEST](state, request) {
    if (!state.shareRequests[request.requestedTicketId]) {
      Vue.set(state.shareRequests, request.requestedTicketId, {});
    }

    if (!state.shareRequests[request.requestedTicketId][request.id]) {
      Vue.set(state.shareRequests[request.requestedTicketId], request.id, {});
    }

    state.shareRequests[request.requestedTicketId][request.id] = request;
  },

  [types.SET_SHARE_TICKET_REQUESTS_PAGE](
    state,
    { id, items, page, nbPages, nbResults, maxPerPage }
  ) {
    if (!state.shareRequests[id]) {
      Vue.set(state.shareRequests, id, {});
    }

    items.forEach(item => Vue.set(state.shareRequests[id], item.id, item));

    if (!state.shareRequestsPaginator[id]) {
      Vue.set(state.shareRequestsPaginator, id, {
        pages: {},
        nbResults: 0,
        nbPages: 0,
      });
    }
    state.shareRequestsPaginator[id].nbPages = nbPages;
    state.shareRequestsPaginator[id].nbResults = nbResults;
    state.shareRequestsPaginator[id].maxPerPage = Number(maxPerPage);

    Vue.set(
      state.shareRequestsPaginator[id].pages,
      page,
      items.map(item => item.id)
    );
  },

  [types.ADD_CUSTOMER_TICKET_HISTORY_PAGE](
    state,
    { id, items, page, nbPages }
  ) {
    if (!state.history[id]) {
      Vue.set(state.history, id, {});
    }

    items.forEach(item => Vue.set(state.history[id], item.id, item));

    if (!state.historyPaginator[id]) {
      Vue.set(state.historyPaginator, id, {
        pages: {},
        nbResults: 0,
        nbPages: 0,
      });
    }
    state.historyPaginator[id].nbPages = nbPages;

    Vue.set(
      state.historyPaginator[id].pages,
      page,
      items.map(item => item.id)
    );
  },
};
